import { render, staticRenderFns } from "./CarletonFooter.vue?vue&type=template&id=699b4cf3&scoped=true&"
import script from "./CarletonFooter.vue?vue&type=script&lang=js&"
export * from "./CarletonFooter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "699b4cf3",
  null
  
)

export default component.exports